<template>
  <div class="notification">
    <div class="notification-header">
      <span class="notification-title">{{notification.title}}</span>
      <span class="notification-share-icon">
        <IconShare v-on:tap="shareNotification" />
      </span>
    </div>
    <div class="notification-body">
      {{notification.body}}
      <div class="notification-footer swipe-container-util">
        <div v-on:tap="removeNotification">Elimina notifica</div>
      </div>
    </div>
  </div>
</template>
<script>
import IconShare from '../assets/rds-life-fonticons/Icona_share.svg?inline';
const navigator = window.navigator;
export default {
  name: 'RdsNotification',
  components: {
    IconShare
  },
  props: ['notification'],
  data() {
    return {};
  },
  methods: {
    removeNotification() {
      this.$emit('removeNotification', this.notification);
    },
    shareNotification() {
      if (navigator.share) {
        navigator.share({
          title: this.notification.title,
          text: this.notification.body,
          url: 'https://lifefe.betards.ninja/navetta'
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.notification {
  margin: 20px;
  letter-spacing: $default-letter-spacing;
  font-weight: 600;

  & + .notification {
    margin-top: 0;
  }
  .notification-header {
    display: flex;
    @include dotted-bottom;
    // &::after {
    //   // background-image: linear-gradient(to right, #707070 50%, rgba(255, 255, 255, 0) 0%);
    //   // background-image: linear-gradient(90deg, #707070, #707070 75%, transparent 75%, transparent 100%);
    //   background-image: url('../../assets/images/linea_tratteggiata_orizzontale.svg');
    //   background-position: bottom;
    //   background-repeat: repeat-x;
    //   content: '';
    //   position: absolute;
    //   width: 96%;
    //   bottom: 0;
    //   left: 2%;
    //   height: 10px;
    // }
    .notification-title {
      flex-grow: 1;
    }
    .notification-share-icon svg path {
      fill: $main-sky;
    }
  }
  .notification-header,
  .notification-body {
    padding: 22px;
    border-radius: 10px;
    background-color: #ffffff;
    font-size: 15px;
    line-height: 1.3;
  }
  .notification-body {
    color: rgba(0, 0, 0, 0.6);
  }
  .notification-footer {
    // margin: 12px 0;
    margin: 0 -12px;
    padding: 12px;
    & > div {
      color: #a31313;
      margin: 0;
      padding: 0;
      font-weight: 600;
    }
  }
}
</style>
